import React, { useEffect } from "react";
import HlsPlayer from "./HlsPlayer"; // Asegúrate de que el HlsPlayer esté en el mismo directorio o ajusta la ruta
import axios from "axios";
import { its_access } from "../../hooks/useAssets";

interface PTZPlayerProps {
    src: string; // URL del archivo HLS (.m3u8)
    backendUrl: string; // URL del backend para los comandos PTZ
    width?: string; // Ancho del video
    height?: string; // Alto del video
    asset_id: number;
}

const { REACT_APP_LOCAL_SERVER, REACT_APP_CCTV_TEST_URL, REACT_APP_CCTV_TEST_USER, REACT_APP_CCTV_TEST_PASS } = process.env;

const PTZPlayer: React.FC<PTZPlayerProps> = ({ src, backendUrl, width = "100%", height = "auto", asset_id }) => {
    const { xaddr, user, pass } = its_access.find(item => item.id === asset_id) || { xaddr: "", user: "", pass: "" };
    // const { xaddr, user, pass } = { xaddr: REACT_APP_CCTV_TEST_URL, user: REACT_APP_CCTV_TEST_USER, pass: REACT_APP_CCTV_TEST_PASS };

    // console.log("🚀 ~ { xaddr, user, pass }:", { xaddr, user, pass })
    const url = new URL(xaddr || '');
    const hostname = url.hostname;

    useEffect(() => {
        const initializeCamera = async () => {
            try {
                const initializeFetch = await fetch(`${REACT_APP_LOCAL_SERVER}/api/ptzWsdl/initialize`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        hostname: hostname,
                        username: user,
                        password: pass,
                        port: 80,
                        timeout: 10000
                    }),
                });
                console.log(`Cámara iniciada.`, initializeFetch);
            } catch (error) {
                console.error('Error al iniciar la cámara:', error);
            }
        }
        initializeCamera();
    }, []);

    const handlePtzControl = async (action: string) => {
        try {
            // const response = await axios.post(`${backendUrl}/api/ptz`, { xaddr, user, pass, action });
            // console.log(`Acción ${action} enviada al backend`);
            // console.log("🚀 ~ handlePtzControl ~ response:", response)
            let x_speed = 0, y_speed = 0, zoom_speed = 0;
            switch (action) {
                case "up": y_speed = 1; break;
                case "down": y_speed = -1; break;
                case "left": x_speed = -1; break;
                case "right": x_speed = 1; break;
                case "zoom in": zoom_speed = 1; break;
                case "zoom out": zoom_speed = -1; break;
                default: break;
            }
            const response = await axios.post(`${backendUrl}/api/ptzWsdl/move`, { hostname, x_speed, y_speed, zoom_speed, direction: action });
            console.log(`Acción ${action} enviada al backend`);
            console.log("🚀 ~ handlePtzControl ~ response:", response)
        } catch (error) {
            console.error(`Error enviando acción ${action}:`, error);
        }
    };

    return (
        <div className="ptz-container" style={{ width, height }}>
            <HlsPlayer
                src={src}
                width="800px"
                height="450px"
                autoPlay={true}
                controls={false}
            />
            <div className="ptz-controls">
                <button className="control-button" onClick={() => handlePtzControl("up")}>▲</button>
                <div>
                    <button className="control-button" onClick={() => handlePtzControl("left")}>◄</button>
                    <button className="control-button" onClick={() => handlePtzControl("right")}>►</button>
                </div>
                <button className="control-button" onClick={() => handlePtzControl("down")}>▼</button>
                <div>
                    <button className="control-button" onClick={() => handlePtzControl("zoom-in")}>Zoom +</button>
                    <button className="control-button" onClick={() => handlePtzControl("zoom-out")}>Zoom -</button>
                </div>
            </div>
        </div>
    );
};

export default PTZPlayer;
